import styled from "styled-components";

export default styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  alig-self: center;
  height: 28rem;
  width: 100vw;
  // background-color: #F2ABB8;
  color: #fff;
  margin: 15px;
  font-size: 4rem;
`;

